import { env as public_env } from "$env/dynamic/public";

const mode = import.meta.env.MODE as "production" | "staging" | "development";

const isProductionOrStaging = ["production", "staging"].includes(mode);

export const env = {
	...public_env,

	isDevelopment: mode === "development",
	isProductionOrStaging,
	logToSentry: isProductionOrStaging || (mode === "development" && public_env.PUBLIC_LOG_TO_SENTRY === "true")
};
